import { render, staticRenderFns } from "./MainLargeDialog.vue?vue&type=template&id=0436c43a&scoped=true&"
import script from "./MainLargeDialog.vue?vue&type=script&lang=js&"
export * from "./MainLargeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436c43a",
  null
  
)

export default component.exports